export const PAGE_NAME: string = 'file-request-submission';
export const ACTION_ADD_ITEMS: string = 'ADD_ITEMS';
export const ACTION_ITEMS_FILTERED_FROM_ADD: string =
  'ACTION_ITEMS_FILTERED_FROM_ADD';
export const ACTION_SUBMIT: string = 'ACTION_SUBMIT';
export const ACTION_SIMULATE_SUBMIT: string = 'ACTION_SIMULATE_SUBMIT';
export const ACTION_TOO_MANY_FILES: string = 'ACTION_TOO_MANY_FILES';
export const ACTION_FILE_SIZE_LIMIT_EXCEEDED: string =
  'ACTION_FILE_SIZE_LIMIT_EXCEEDED';
export const ACTION_INVALID_FILE_NAME: string = 'ACTION_INVALID_FILE_NAME';
export const ACTION_UPLOAD_IN_PROGRESS: string = 'ACTION_UPLOAD_IN_PROGRESS';
export const ACTION_SUBMIT_IN_PROGRESS: string = 'ACTION_SUBMIT_IN_PROGRESS';
export const ACTION_REMOVE_ITEM: string = 'ACTION_REMOVE_ITEM';
export const ACTION_SELECT_FIELD_ON_CHANGE: string =
  'ACTION_SELECT_FIELD_ON_CHANGE';
export const ACTION_TAXONOMY_FIELD_ON_CHANGE: string =
  'ACTION_TAXONOMY_FIELD_ON_CHANGE';
export const ACTION_TEXT_FIELD_ON_CHANGE: string =
  'ACTION_TEXT_FIELD_ON_CHANGE';
export const ACTION_DATE_FIELD_ON_CHANGE: string =
  'ACTION_DATE_FIELD_ON_CHANGE';
export const ACTION_TOGGLE_UPLOAD_MANAGER: string =
  'ACTION_TOGGLE_UPLOAD_MANAGER';
export const ACTION_UPLOAD_PROGRESS_UPDATE: string =
  'ACTION_UPLOAD_PROGRESS_UPDATE';
export const ACTION_ON_ALL_FILES_UPLOADED: string =
  'ACTION_ON_ALL_FILES_UPLOADED';
export const ACTION_VALIDATION_FAILED: string = 'ACTION_VALIDATION_FAILED';
export const ACTION_CLOSE_NOTIFICATION: string = 'ACTION_CLOSE_NOTIFICATION';
export const ACTION_SUBMISSION_FAILED: string = 'ACTION_SUBMISSION_FAILED';
export const ACTION_PROCESSING_IN_PROGRESS: string =
  'ACTION_PROCESSING_IN_PROGRESS';
export const ACTION_LIST_FIELD_ON_CHANGE: string =
  'ACTION_LIST_FIELD_ON_CHANGE';
export const ACTION_UPDATE_COMPONENTS: string = 'ACTION_UPDATE_COMPONENTS';
export const ACTION_NUMBER_FIELD_ON_CHANGE: string =
  'ACTION_NUMBER_FIELD_ON_CHANGE';
export const ACTION_UPLOAD_FIELD_FILE_DESCRIPTION_ON_CHANGE: string =
  'ACTION_UPLOAD_FIELD_FILE_DESCRIPTION_ON_CHANGE';
export const ACTION_TOGGLE_TOS_CHECKBOX: string = 'ACTION_TOGGLE_TOS_CHECKBOX';
